export const iconFontAwesomeTimeCalendarCheck = (
	<i className="fa-solid fa-calendar-check"></i>
);
